const SecondaryDistribution = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

          <div className="px-1 flex flex-col justify-center lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem]">
            <h1 className="font-bold sm:text-3xl text-2xl text-[#373737]">
              Secondary Distribution
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS secondary distribution services, responsible for getting retail stocks to the markets and 
              shops across the lengths and breadths of Pakistan provides an unmatched level of penetration 
              of Pakistan’s economic landscape.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              We take the hassle out of more in-depth planning of time and resources by optimising factors, 
              such as route defining and sequencing deliveries, vehicle load, order of distribution, offloading times, 
              labour laws, safety and security, etc.
            </p>
           
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/distribution/Secondary-Distrinution-Inside.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </ div>

      </div>

    </div>
  );
};
  
export default SecondaryDistribution;
  